import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"

interface UseArchivePublicCompanyProps {
  publicCompanyLeadId?: string
  onSuccess?: () => void
  onError?: () => void
}

export const useArchivePublicCompanyLead = ({
  publicCompanyLeadId,
  onSuccess,
  onError,
}: UseArchivePublicCompanyProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['archivePublicCompany'],
    mutationFn: async (newStatus: string) => {
      await privateAxios.put(`/funnel/public/leads/${publicCompanyLeadId}/${newStatus}`)
    },
    onSuccess,
    onError,
  })
}
